// extracted by mini-css-extract-plugin
module.exports = {"permanent":"Link--permanent--XZUql","link":"Link--link--7RcZf","link__active":"Link--link__active--1utqB","link__icon":"Link--link__icon--TaOzA","centered":"Link--centered--1SNiN"};